import { useState } from "react";
import { useLocation } from "react-router-dom";
import { UtmService } from "lib/services/UtmService/UtmService";

export const useUtmParams = () => {
  const location = useLocation();
  const [utmParams] = useState(new UtmService().getUtmParams(location, document.cookie));
  return utmParams;
};
